module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Higher_minus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Higher_minus.png
// module id = 1162
// module chunks = 0